// extracted by mini-css-extract-plugin
module.exports = {"successMessageBox":"successMessage_successMessageBox__Wt8TQ","icon":"successMessage_icon__nhKpv","message":"successMessage_message__ypxCK"};